import Resultado from "./Resultado";

const FormatoMoeda = new Intl.NumberFormat("pt-BR", { style: 'currency', currency: 'BRL' });
const FormatoData = new Intl.DateTimeFormat("pt-BR");
const FormatoDataHora = new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "long" });

class Central {

    urlCentral = "../"
    kit = {};
    kitCarregado = false;
    autenticado = false;
    usuarioLogado = null;

    constructor() {
        if (process.env.NODE_ENV === "production") {
            this.urlCentral = "../";
        } else {
            this.urlCentral = "http://localhost:8082/provedor-dev";
        }
    }

    onPrecisaLogar = function () {
        console.log("On precisa logar (dummy)");

    }

    defaultErro = function (erro) {
        console.log("ERRO: " + erro);
    }

    onLogin = function (whoami) {
        console.log("Login OK");
    }

    onLogout = function () {
        console.log("Logout OK");
    }

    onNotificacao = function (mensagem) {
        console.log("NOTIFICAÇÃO: " + mensagem);
    }

    getUrlLogo() {
        return this.urlCentral + "/logo";
    }

    login(login, onSucesso, onFalha, onCleanup) {
        this.requestAndCatch("POST", "/login", JSON.stringify({ login: login }),
            (payload) => {
                if (payload.tipo === "LOGIN_OK") {
                    this.autenticado = true;
                    this.usuarioLogado = payload.usuario;
                    onSucesso(payload.usuario);
                    this.onLogin(payload.whoami);
                    return;
                } else {
                    onFalha(payload.mensagem);
                }
            },
            (msg) => {
                onFalha(msg)
            },
            () => {
                onCleanup();
            });
    }

    logout(onSucesso) {
        this.request("POST", "/logout", null, () => {
            this.autenticado = false;
            this.usuarioLogado = null;
            this.onLogout();
        },
            () => {

            })
    }

    fetchKit(onRetorno) {
        if (this.kitCarregado) {
            onRetorno();
            return;
        }
        this.requestAndCatch("GET", "/login/kit", null,
            payload => {
                this.kit = payload;
                this.kitCarregado = true;
                console.log("Versão servidor: " + this.kit.versao);
                if (onRetorno != null) {
                    onRetorno();
                }
            },
            erro => {
                console.log("Erro: Impossivel acessar LoginKit da central: " + erro);
            });
    }

    requestAndCatch(metodo, url, body, onRetorno, onErro, cleanUp = () => { }, onPrecisaLogar = this.onPrecisaLogar) {
        var headers = {};
        if (metodo === "POST") {
            headers = { "Content-Type": "application/json" };
        }
        var req = new Request(this.urlCentral + "/central/api" + url,
            {
                method: metodo,
                headers: headers,
                body: body,
                credentials: "include"
            }
        );
        var prom = fetch(req);
        prom
            .then((response) => {
                if (response.ok) {
                    if (response) {
                        return response.json().then((data) => {
                            onRetorno(data);
                            cleanUp();
                        }).catch((ex) => {
                            onRetorno(null);
                            cleanUp();
                        });
                    }
                } else {
                    if (response.status === 403) {
                        onPrecisaLogar();
                        cleanUp();
                    } else {
                        throw new Error("Erro: " + response.statusText + " (" + response.status + ")");
                    }
                }

            }).catch(function (erro) {
                onErro(erro.message);
                cleanUp();
            });
    }

    setOnPrecisaLogar(f) {
        this.onPrecisaLogar = f;
    }

    request(method, url, body, onRetorno, cleanUp = function () { }) {
        this.requestAndCatch(method, url, body, onRetorno, this.defaultErro, cleanUp, this.onPrecisaLogar);
    }

    listaContas(onRetorno, onErro, cleanUp = function () { }) {
        this.requestAndCatch("GET", "/contas", null, (payload) => { onRetorno(new Resultado(payload)) }, onErro, cleanUp);
    }
}

const central = new Central();
export default central;
export { FormatoMoeda, FormatoData, FormatoDataHora };
